
import { Vue } from "vue-class-component";

export default class BookingClientV2 extends Vue {}
